export const GET_STATUSES = 'GET_STATUSES';
export const GET_BRANDS = 'GET_BRANDS';
export const GET_TYPES = 'GET_TYPES';
export const GET_PRODUCTS = 'GET_PRODUCTS';

export default {
  GET_STATUSES,
  GET_BRANDS,
  GET_TYPES,
  GET_PRODUCTS,
};




// WEBPACK FOOTER //
// ./src/store/modules/product/mutation-types.js